import { Check } from "@mui/icons-material";
import { Stack, Box, useTheme } from "@mui/material";

export default function Steps({length, value, onChange}){

    const theme = useTheme();

    const blue = theme.palette.primary.main;

    
    const bullOff = {
        height: 22,
        width: 22,
        minWidth: 22,
        borderRadius: '50%',
        border: 'solid 2px lightgrey',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    };

    const bullOn = {...bullOff, 
        border: 'solid 2px ' + blue,
    }

    const bullOk = {...bullOn,
        backgroundColor: blue,
        cursor: 'pointer'
    };

    const barOff = {
        height: 2,
        backgroundColor: 'lightgrey',
        flex: 1
    }

    const barOn = {...barOff,
        backgroundColor: blue,
    }


    const check = {
        color: 'white',
        width: '90%'
    }


    return <Stack direction='row' alignItems='center' width='100%'>

        {[...Array(length).keys()]
            .map(s => 
                <Box 
                    key={'bull' + s}
                    sx={s === value ? bullOn : (s < value ? bullOk : bullOff)} 
                    onClick={() => s < value ? onChange(s) : null}
                >
                    {s < value && <Check sx={check} />}
                </Box>
            )
            .reduce((a,b,i) => 
                [a, <Box 
                        key={'bar' + i} 
                        sx={i <= value ? barOn : barOff}
                    >
                    </Box>
                , b]
            )
        }

    </Stack>
}